'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { DragLayer } from 'react-dnd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import { MONOLITH } from 'HubStyleTokens/colors';
import { ROOT_FONT_SIZE } from 'HubStyleTokens/sizes';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFolderNav from 'UIComponents/nav/UIFolderNav';
import UIFolderNavItem from 'UIComponents/nav/UIFolderNavItem';
import { FINDER_FILE, FINDER_FOLDER } from 'DesignData/enums/DragDropItemTypes';
import { isNullOrUndefined } from 'DesignData/lib/validation';
import File from 'DesignData/models/finder/File';
import Folder from 'DesignData/models/finder/Folder';
import * as finderSelectors from 'DesignData/selectors/finder';
import DragHandle from 'DesignFinderUI/components/dnd/DragHandle';
import { compose } from 'redux';
import { getIconNameFromFolderAssetType } from 'DesignData/lib/icon';
const OFFSET_X = 20;
const OFFSET_Y = 30;

function mapStateToProps(state) {
  return {
    selectedAssetsCount: finderSelectors.getSelectedAssetsCount(state)
  };
}

function collect(monitor) {
  return {
    currentOffset: monitor.getClientOffset(),
    item: monitor.getItem(),
    itemType: monitor.getItemType()
  };
}

function getLayerStyles() {
  return {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0
  };
}

function getItemStyles(props) {
  const {
    currentOffset
  } = props;

  if (!currentOffset) {
    return {
      display: 'none'
    };
  }

  const {
    x,
    y
  } = currentOffset;
  const transform = `translate(${x - OFFSET_X}px, ${y - OFFSET_Y}px)`;
  return {
    position: 'relative',
    transform,
    WebkitTransform: transform,
    minWidth: 150,
    width: 'auto',
    transition: 'none !important',
    WebkitTransition: 'none !important'
  };
}

class FinderDragLayer extends Component {
  renderFinderDragPreview(title, icon) {
    const {
      canDrop
    } = this.props;
    const layerStyles = getLayerStyles();
    const itemStyles = getItemStyles(this.props);
    const renderedBanIcon = !isNullOrUndefined(canDrop) && !canDrop ? /*#__PURE__*/_jsx(UIIcon, {
      color: MONOLITH,
      name: "remove"
      /* Should be BAN */
      ,
      style: {
        position: 'absolute',
        left: OFFSET_X * 1.5,
        bottom: `-${ROOT_FONT_SIZE}`
      }
    }) : null;
    return /*#__PURE__*/_jsx("div", {
      style: layerStyles,
      children: /*#__PURE__*/_jsxs(UICardWrapper, {
        className: "p-left-2 p-right-5",
        compact: true,
        style: itemStyles,
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(DragHandle, {}), /*#__PURE__*/_jsx(UIFolderNav, {
            className: "m-bottom-0 p-bottom-0",
            children: /*#__PURE__*/_jsx(UIFolderNavItem, {
              className: "p-x-0",
              iconLeft: icon,
              title: title
            })
          })]
        }), renderedBanIcon]
      })
    });
  }

  renderFilePreview() {
    const {
      file
    } = this.props.item;
    const fileIcon = getIconNameFromFolderAssetType(file.type, file.path);
    return this.renderFinderDragPreview(file.name, fileIcon);
  }

  renderFolderPreview() {
    const {
      folder
    } = this.props.item;
    return this.renderFinderDragPreview(folder.name, 'folder');
  }

  render() {
    const {
      isDragging,
      item,
      itemType,
      selectedAssetsCount
    } = this.props;

    if (!(isDragging && item)) {
      return null;
    }

    if (!(itemType === FINDER_FILE || itemType === FINDER_FOLDER)) {
      return null;
    }

    if (item.isMultiSelected) {
      return this.renderFinderDragPreview(text('DesignFinderUI.dnd.FinderDragLayer.selectedItems', {
        count: selectedAssetsCount
      }), 'documents');
    }

    if (itemType === FINDER_FILE) {
      return this.renderFilePreview();
    }

    if (itemType === FINDER_FOLDER) {
      return this.renderFolderPreview();
    }

    return null;
  }

}

FinderDragLayer.propTypes = {
  canDrop: PropTypes.bool,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool,
  item: PropTypes.shape({
    file: PropTypes.instanceOf(File),
    folder: PropTypes.instanceOf(Folder),
    isMultiSelected: PropTypes.bool
  }),
  itemType: PropTypes.string,
  selectedAssetsCount: PropTypes.number
};
FinderDragLayer.defaultProps = {
  canDrop: null,
  currentOffset: null,
  isDragging: false,
  item: null,
  itemType: null,
  selectedAssetsCount: 0
};
export default compose(connect(mapStateToProps), DragLayer(collect))(FinderDragLayer);